import Header from '../components/Header';
import Footer from '../components/Footer';

export default function PolicyLayout({ title, children }) {
  return (
    <div className="policy-page">
      <Header />
      <main className="policy-main">
        <div className="policy-content-wrap">
          <h1 className="policy-title">{title}</h1>
          <div className="policy-content">{children}</div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
